import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { fetchLoginViaPassword } from 'src/store/auth/asyncThunk';
import { BaseDialog, BaseDivider } from '../../../components/common';
import { SocialButtons } from '../../../components/fields/buttons/socialButtons/SocialButtons';
import { checkIsLoading } from 'src/utils/types/statuses';
import { LoginForm, PLoginForm } from './LoginForm';
import { ILoginModel } from '../../../api/base/Auth/types';
import { MsCodeModal } from '../../user/common/msAuth/modals/MsCodeModal';
import { useResponseAuth } from '../../../pages/auth/useResponseAuth';

type PLoginModal = Pick<PLoginForm, 'onForgotPassword' | 'onRegisterClick'> & {
  open: boolean;
  onClose: () => void;
};

export const LoginModal: React.FC<PLoginModal> = (props) => {
  const { open, onClose, onRegisterClick, onForgotPassword } = props;
  const { requests, user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState<ILoginModel | null>(null);
  const handleLogin = async (data: ILoginModel) => {
    setCredentials(data);
    const result = await dispatch(fetchLoginViaPassword(data));
	const redirectUrl = localStorage.getItem('redirectAfterLogin');
	  if(redirectUrl) {
		  localStorage.removeItem('redirectAfterLogin');
		  onClose();
		  setTimeout(() => {
			  window.location.href = redirectUrl;
		  }, 50);
	  }		  
	  else {
		  window.location.href = '/dashboard';
	  }
  };

  const { msModalVisible, setMsModalVisibility } = useResponseAuth({
    user: user!,
    request: requests.loginViaPassword,
    onSuccess: onClose,
  });
	
  const user_type = (localStorage.getItem('userType') === 'Journalist') ? 'a' : 'an';

  return (
    <>
      <BaseDialog
        open={open}
        paperStyles={{ maxWidth: '420px', width: '100%' }}
        onClose={onClose}
        title={`Login as ${user_type} ${localStorage.getItem('userType')}`}
      >
        <SocialButtons />
        <BaseDivider />
        <LoginForm
          loading={checkIsLoading(requests.loginViaPassword.status)}
          errors={requests?.loginViaPassword?.error?.data?.errors}
          onSubmit={handleLogin}
          onRegisterClick={onRegisterClick}
          onForgotPassword={onForgotPassword}
        />
      </BaseDialog>

      <MsCodeModal
        loading={checkIsLoading(requests.loginViaPassword.status)}
        onClose={() => setMsModalVisibility(false)}
        onConfirm={(data) => {
          if (credentials) {
            handleLogin({ ...credentials, ...data });
          }
        }}
        open={msModalVisible}
      />
    </>
  );
};
